import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_API_KEY } from "../../env";
const stripePromise = loadStripe(STRIPE_API_KEY);
const stripeElementsOptions = {
  fonts: [
    {
      cssSrc: "https://fonts.googleapis.com/css?family=Overpass",
    },
  ],
};
export { Elements, stripePromise, stripeElementsOptions };
